// @ts-nocheck
import React, { useEffect, useState } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import {
	StyledContactUsCheckboxesContainer,
	StyledSubTitleGrid,
	StyledSubTitle,
	StyledGridContainerForCheckboxes,
	StyledError,
} from './contact-us-styles'
import { Controller } from 'react-hook-form'
import styled from 'styled-components'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from 'components/common/TextField'

const labelStyle = `{
	fontSize: '12px',
	lineHeight: '1.2',
	color: '#010101',
	fontFamily: 'Work Sans',
}`

const rootStyle = `{
	marginInlineStart: '-10px',
	marginBottom: '6px',
	'@media(min-width: 577px)': {
		marginInlineStart: '-28px',
	}`

// couldn't use TypographyPro for this one - had to use the props from the theme instead
const StyledFormControlLabel = styled(FormControlLabel)`
	margin: 0;
	& .MuiTypography-body1 {
		font-size: ${(props) => props.theme.typography.BodyRegular.fontSize};
		font-family: ${(props) => props.theme.typography.BodyRegular.fontFamily};
	}
`

const ContactUsCheckboxes = ({ control, listenToCheckboxes, showError, clearErrors, setValue, unregister, lang, shouldBeContacted }) => {
	const [checkboxes, setCheckboxes] = useState({
		phone: false,
		email: false,
		noContact: false,
	})

	useEffect(() => {
		listenToCheckboxes(checkboxes)
	}, [checkboxes])

	// according to Germany PH specification phone and e-mail can be both checked
	const checkboxChangeHandler = (checkboxName) => {
		if (checkboxName === 'phone' || checkboxName === 'email') {
			// if checkbox state is true it will now turn false and then we unregister it from the form
			if (checkboxes[checkboxName]) {
				clearErrors(checkboxName)
			}
			setCheckboxes((prevState) => ({ ...prevState, [checkboxName]: !prevState[checkboxName], noContact: false }))
			unregister(checkboxName)
		} else {
			setCheckboxes((prevState) => ({
				...prevState,
				[checkboxName]: !prevState[checkboxName],
				phone: false,
				email: false,
			}))
			shouldBeContacted(false)
			unregister(['phone', 'email'])
		}
	}

	return (
		<>
			<StyledSubTitleGrid item xs={12} sm={12} md={12} style={{ margin: '-5px 0' }}>
				<StyledSubTitle variant="BodyRegularHighlighted">{lang.webviewFlow.howWeMayContactYou} *</StyledSubTitle>
				{showError && <StyledError data-testid="checkbox-error">{lang.webviewFlow.howWeMayContactYouError}</StyledError>}
			</StyledSubTitleGrid>
			<StyledContactUsCheckboxesContainer>
				<StyledFormControlLabel
					control={
						<div>
							<Checkbox
								inputProps={{ 'data-testid': 'checkbox-phone' }}
								checked={checkboxes.phone}
								name="checkedB"
								style={{ transform: 'scale(1.2)', borderRadius: 'none', color: 'black' }}
							/>
						</div>
					}
					label={lang.webviewFlow.byPhone}
					name="PhoneCheckbox"
					classes={{ label: labelStyle, root: rootStyle }}
					onChange={() => checkboxChangeHandler('phone')}
				/>
				{checkboxes.phone && (
					<Controller
						control={control}
						name="phone"
						defaultValue=""
						render={({ field, fieldState: { invalid, error } }) => (
							<StyledGridContainerForCheckboxes item xs={12} sm={12} md={12}>
								<TextField
									label={lang.webviewFlow.pleaseSharePhoneNumber}
									field={field}
									error={invalid}
									errorMessage={error?.message}
									required
									inputProps={{
										'data-testid': 'share-phone-input',
									}}
								/>
							</StyledGridContainerForCheckboxes>
						)}
					/>
				)}
				<StyledFormControlLabel
					control={
						<div>
							<Checkbox
								inputProps={{ 'data-testid': 'checkbox-email' }}
								checked={checkboxes.email}
								name="checkedB"
								style={{ transform: 'scale(1.2)', borderRadius: 'none', color: 'black' }}
							/>
						</div>
					}
					label={lang.webviewFlow.byEmail}
					name="EmailCheckbox"
					classes={{ label: labelStyle, root: rootStyle }}
					onChange={() => checkboxChangeHandler('email')}
				/>
				{checkboxes.email && (
					<Controller
						control={control}
						name="email"
						defaultValue=""
						render={({ field, fieldState: { invalid, error } }) => (
							<StyledGridContainerForCheckboxes item xs={12} sm={12} md={12}>
								<TextField
									label={lang.webviewFlow.pleaseShareEmailAddress}
									field={field}
									error={invalid}
									errorMessage={error?.message}
									required
									inputProps={{
										'data-testid': 'share-email-address-input',
									}}
								/>
							</StyledGridContainerForCheckboxes>
						)}
					/>
				)}
				<StyledFormControlLabel
					control={
						<div>
							<Checkbox
								inputProps={{ 'data-testid': 'checkbox-no-contact–interested' }}
								checked={checkboxes.noContact}
								name="checkedB"
								style={{ transform: 'scale(1.2)', borderRadius: 'none', color: 'black' }}
							/>
						</div>
					}
					label={lang.webviewFlow.noContact}
					name="NoContactCheckbox"
					classes={{ label: labelStyle, root: rootStyle }}
					onChange={() => checkboxChangeHandler('noContact')}
				/>
			</StyledContactUsCheckboxesContainer>
		</>
	)
}

export default ContactUsCheckboxes
